import { render, staticRenderFns } from "./DataTableIrreversibleDeleteModal.vue?vue&type=template&id=1fd1a726&scoped=true&"
import script from "./DataTableIrreversibleDeleteModal.vue?vue&type=script&lang=js&"
export * from "./DataTableIrreversibleDeleteModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd1a726",
  null
  
)

export default component.exports